// =====================
// ====== General ======
// =====================
export const CHECKOUT_SET_PERSONAL_DETAILS = "CHECKOUT_SET_PERSONAL_DETAILS";
export const CHECKOUT_SET_MEMBER_DETAILS = "CHECKOUT_SET_MEMBER_DETAILS";
export const CHECKOUT_SET_TRANSFER_OWNER_PERSONAL_DETAILS = "CHECKOUT_SET_TRANSFER_OWNER_PERSONAL_DETAILS";
export const CHECKOUT_EMPTY_ORDER = "CHECKOUT_EMPTY_ORDER";
export const CHECKOUT_EXTEND_ORDER = "CHECKOUT_EXTEND_ORDER";
export const CHECKOUT_RESET_ORDER = "CHECKOUT_RESET_ORDER";
export const CHECKOUT_RESET_MEMBER = "CHECKOUT_RESET_MEMBER";

// ===========================
// ====== Customer Info ======
// ===========================
export const CHECKOUT_SET_VALUE = "CHECKOUT_SET_VALUE";

// ==========================
// ====== Verification ======
// ==========================
export const CHECKOUT_SEND_CODE = "CHECKOUT_SEND_CODE";
export const CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP = "CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP";
export const CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN =
    "CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN";

// ==========================
// ====== Account ======
// ==========================
export const CHECKOUT_SET_SELECTED_ACCOUNT = "CHECKOUT_SET_SELECTED_ACCOUNT";
export const CHECKOUT_SEND_SMS = "CHECKOUT_SEND_SMS";
export const CHECKOUT_SET_OFFERING_CODE = "CHECKOUT_SET_OFFERING_CODE";
export const CHECKOUT_SET_TRANSFER_DATE = "CHECKOUT_SET_TRANSFER_DATE";

// ===========================
// ====== Phone Numbers ======
// ===========================
export const CHECKOUT_CHOOSE_PHONE_NUMBER_SWITCH_PANEL = "CHECKOUT_CHOOSE_PHONE_NUMBER_SWITCH_PANEL";
export const CHECKOUT_FETCH_AVAILABLE_PHONE_NUMBERS = "CHECKOUT_FETCH_AVAILABLE_PHONE_NUMBERS";
export const CHECKOUT_CHECK_EXISTING_PHONE_NUMBER = "CHECKOUT_CHECK_EXISTING_PHONE_NUMBER";
export const CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER = "CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER";
export const CHECKOUT_CHECK_EXISTING_PHONE_NUMBER_TRANSFER_OWNERSHIP =
    "CHECKOUT_CHECK_EXISTING_PHONE_NUMBER_TRANSFER_OWNERSHIP";
export const CHECKOUT_SET_SELECTED_PHONE_NUMBER = "CHECKOUT_SET_SELECTED_PHONE_NUMBER";
export const CHECKOUT_SET_CAN_SEND_TRANSFER_ORDER = "CHECKOUT_SET_CAN_SEND_TRANSFER_ORDER";

// ======================
// ====== Delivery ======
// ======================
export const CHECKOUT_SET_DELIVERY_TYPE = "CHECKOUT_SET_DELIVERY_TYPE";
export const CHECKOUT_SET_DELIVERY_CODE = "CHECKOUT_SET_DELIVERY_CODE";
export const CHECKOUT_SET_DELIVERY_NOTE = "CHECKOUT_SET_DELIVERY_NOTE";
export const CHECKOUT_SET_DELIVERY_ZIPCODE = "CHECKOUT_SET_DELIVERY_ZIPCODE";
export const CHECKOUT_UPDATE_DELIVERY_ADDRESS = "CHECKOUT_UPDATE_DELIVERY_ADDRESS";
export const CHECKOUT_FIND_DELIVERY_ADDRESS = "CHECKOUT_FIND_DELIVERY_ADDRESS";

// =====================
// ====== Payment ======
// =====================
export const CHECKOUT_PAYMENT = "CHECKOUT_PAYMENT";
export const CHECKOUT_SET_SELECTED_PAYMENT_TYPE = "CHECKOUT_SET_SELECTED_PAYMENT_TYPE";
export const CHECKOUT_RESET_LEASE_ERROR = "CHECKOUT_RESET_LEASE_ERROR";
export const CHECKOUT_CLOSE_DELAY_ON_PURCHASE_MODAL = "CHECKOUT_CLOSE_DELAY_ON_PURCHASE_MODAL";

// =====================
// ======= Cart ========
// =====================
export const CHECKOUT_CART_IS_EXPANDED = "CHECKOUT_CART_IS_EXPANDED";
export const CHECKOUT_CART_SET_ACTIVE_SUBSCRIPTION = "CHECKOUT_CART_SET_ACTIVE_SUBSCRIPTION";
export const CHECKOUT_FETCH_CART = "CHECKOUT_FETCH_CART";
export const CHECKOUT_EMPTY_CART = "CHECKOUT_EMPTY_CART";
export const CHECKOUT_ORDER_HANDSET = "CHECKOUT_ORDER_HANDSET";
export const CHECKOUT_ADD_ACCESSORY_TO_CART = "CHECKOUT_ADD_ACCESSORY_TO_CART";
export const CHECKOUT_REMOVE_ITEM_BY_CART_ITEM_ID_FROM_CART = "CHECKOUT_REMOVE_ITEM_BY_CART_ITEM_ID_FROM_CART";
export const CHECKOUT_ADD_SERVICE_TO_CART = "CHECKOUT_ADD_SERVICE_TO_CART";
export const CHECKOUT_ADD_SUBSCRIPTION_TO_CART = "CHECKOUT_ADD_SUBSCRIPTION_TO_CART";
export const CHECKOUT_ADD_SUBSCRIPTION_IN_BUNDLE_TO_CART = "CHECKOUT_ADD_SUBSCRIPTION_IN_BUNDLE_TO_CART";
export const CHECKOUT_REMOVE_SERVICE_FROM_CART = "CHECKOUT_REMOVE_SERVICE_FROM_CART";
export const CHECKOUT_ADD_BROADBAND_BUNDLE_TO_CART = "CHECKOUT_ADD_BROADBAND_BUNDLE_TO_CART";
export const CHECKOUT_REMOVE_ITEM_BY_ID_FROM_CART = "CHECKOUT_REMOVE_ITEM_BY_ID_FROM_CART";
export const CHECKOUT_ADD_WEBDEAL_ACCESSORY_TO_CART = "CHECKOUT_ADD_WEBDEAL_ACCESSORY_TO_CART";
export const CHECKOUT_SET_MAIN_SUBSCRIPTION = "CHECKOUT_SET_MAIN_SUBSCRIPTION";
export const CHECKOUT_GET_INSURANCE_INFO = "CHECKOUT_GET_INSURANCE_INFO";
export const CHECKOUT_REMOVE_HARDWARE_ITEM_FROM_BUNDLE = "CHECKOUT_REMOVE_HARDWARE_ITEM_FROM_BUNDLE";
export const CHECKOUT_REMOVE_SMART_DISCOUNT_FROM_HARDWARE_ITEM = "CHECKOUT_REMOVE_SMART_DISCOUNT_FROM_HARDWARE_ITEM";
export const CHECKOUT_REMOVE_SMART_DISCOUNT = "CHECKOUT_REMOVE_SMART_DISCOUNT";
export const CHECKOUT_ADD_EXTRA_SIM_TO_CART = "CHECKOUT_ADD_EXTRA_SIM_TO_CART";
export const CHECKOUT_ADD_ONBOARDING_MOBILE_SUPPORT = "CHECKOUT_ADD_ONBOARDING_MOBILE_SUPPORT";
export const CHECKOUT_REMOVE_ONBOARDING_MOBILE_SUPPORT = "CHECKOUT_REMOVE_ONBOARDING_MOBILE_SUPPORT";
export const CHECKOUT_REMOVE_MOBILE_REFUND_FROM_CART = "CHECKOUT_REMOVE_MOBILE_REFUND_FROM_CART";
export const CHECKOUT_APPLY_FLEXIBLE_LEASE = "CHECKOUT_APPLY_FLEXIBLE_LEASE";

// ================================
// ====== Transfer Ownership ======
// ================================
export const CHECKOUT_SUBMIT_TRANSFER_OWNERSHIP_ORDER = "CHECKOUT_SUBMIT_TRANSFER_OWNERSHIP_ORDER";
export const CHECKOUT_UPDATE_FORMER_LEGAL_B2B = "CHECKOUT_UPDATE_FORMER_LEGAL_B2B";
export const CHECKOUT_UPDATE_ORG_CONSENT_TO_B2B = "CHECKOUT_UPDATE_ORG_CONSENT_TO_B2B";
export const CONSENT_TO_B2B_BANKID_RESET = "CONSENT_TO_B2B_BANKID_RESET";
export const CHECKOUT_SUBMIT_PORTIN_DATA = "CHECKOUT_SUBMIT_PORTIN_DATA";
export const CHECKOUT_SUBMIT_PORTIN_TRANSFER_OWNERSHIP_ORDER = "CHECKOUT_SUBMIT_PORTIN_TRANSFER_OWNERSHIP_ORDER";
export const CHECKOUT_REJECT_PORTIN_TRANSFER_OWNERSHIP_ORDER = "CHECKOUT_REJECT_PORTIN_TRANSFER_OWNERSHIP_ORDER";
export const CHECKOUT_REJECT_TRANSFER_OWNERSHIP_ORDER = "CHECKOUT_REJECT_TRANSFER_OWNERSHIP_ORDER";
export const CHECKOUT_SUBMIT_TRANSFER_OWNERSHIP_CONSENT = "CHECKOUT_SUBMIT_TRANSFER_OWNERSHIP_CONSENT";
export const CHECKOUT_REJECT_TRANSFER_OWNERSHIP_CONSENT = "CHECKOUT_REJECT_TRANSFER_OWNERSHIP_CONSENT";
export const CHECKOUT_SET_KEEP_AGREEMENT = "CHECKOUT_SET_KEEP_AGREEMENT";
export const TRANSFER_APPROVE_FROM_FORMER_LEGAL = "TRANSFER_APPROVE_FROM_FORMER_LEGAL";
export const TRANSFER_REJECT_FROM_FORMER_LEGAL = "TRANSFER_REJECT_FROM_FORMER_LEGAL";
export const TRANSFER_SEND_CODE_FROM_FORMER_LEGAL = "TRANSFER_SEND_CODE_FROM_FORMER_LEGAL";
export const TRANSFER_VERIFY_CODE_FROM_FORMER_LEGAL = "TRANSFER_VERIFY_CODE_FROM_FORMER_LEGAL";
export const TRANSFER_RESET_VERIFICATION_FROM_FORMER_LEGAL = "TRANSFER_RESET_VERIFICATION_FROM_FORMER_LEGAL";

// ================================
// ====== Incomplete Order ======
// ================================
export const CHECKOUT_SUBMIT_INCOMPLETE_ORDER_FORM = "CHECKOUT_SUBMIT_INCOMPLETE_ORDER_FORM";

// ================================
// ====== Member ======
// ================================
export const CHECKOUT_GET_EXTRA_SIM_PRICES = "CHECKOUT_GET_EXTRA_SIM_PRICES";
export const CHECKOUT_SET_SELECTED_MEMBER_STEP = "CHECKOUT_SET_SELECTED_MEMBER_STEP";
export const CHECKOUT_UPDATE_PORTIN_DATE = "CHECKOUT_UPDATE_PORTIN_DATE";

// ======================
// ====== Combined ======
// ======================
export const CHECKOUT_FETCH_DELIVERY_AND_PAYMENT_METHODS = "CHECKOUT_FETCH_DELIVERY_AND_PAYMENT_METHODS";
